module.exports = __webpack_public_path__ + "media/images/ibjjf/membership/card-ornament-blue-dark-37d8bb21734b04213a774dea2fae7b9b.svg";